
const ExpiredPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f6f8",
        fontFamily: "Segoe UI, Roboto, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "3rem 2.5rem",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h1
          style={{ fontSize: "2rem", color: "#c0392b", marginBottom: "1rem" }}
        >
          🔒 Link abgelaufen
        </h1>
        <p style={{ fontSize: "1.1rem", color: "#333", marginBottom: "1rem" }}>
          Der benutzte QR-Code / Shortlink ist bereits abgelaufen.
        </p>
        <p style={{ fontSize: "1rem", color: "#555" }}>
          Bitte kontaktieren Sie das <strong>AIS Team</strong>, falls Sie
          Rückfragen haben oder Zugriff benötigen.
        </p>
      </div>
    </div>
  );
};

export default ExpiredPage;
